const authHu = {
    "sign_in": "Sign in",
    "registration": "Registration",
    "email": "Email address",
    "password": "Password",
    "invalid_credentials": "Invalid credentials",
    "login_with_google": "Login with Google",
    "password_min_length": "Password must be at least 8 characters long",
    "forgotten_password": "I forgot my password",
    "unable_to_reset_password": "Password reset failed.",
    "reset_password_title": "Reset password",
    "reset_password_text": "Please enter the email address you used to register with the system. A link to reset your password will be sent to that email address.",
    "send_reset_mail": "Send password reset link",
    "send_reset_mail_success": "A link to reset your password has been sent to that email address",
    "invalid_email": "Invalid email address",
    "reset_sent": "Message sent",
    "reset_email_error": "An error occurred while sending the email",
    "server_unavailable": "The server is unavailable",
    "text_is_empty": "The text cannot be empty",
    "no_restaurant_selected": "There is no restaurant associated with this request. Please contact the administrator.",
    "password_too_short": "Password must be at least 6 characters long",
    "registration_success": "Registration successful. Welcome to the renewed ReservOurs admin panel!",
    "registration_failed": "Registration failed. Please try again later.",
    "registration_title": "ReservOurs registration",
    "register": "Register",
    "registration_information": "Please enter the email address you have previously agreed with the administrator or the recipient of the invitation to register. Your password must be at least 6 characters long.",
    "email_already_in_use": "This email address is already in use. Please choose another one or log in.",
    "invalid_token": "Invalid token. Please log in again.",
}

export default authHu;